<form [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title">{{config.title}}</h5>
    <button (click)="close()" type="button" class="close">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">
      <div class="col-sm-12">
        <app-select-search bindLabel="title"
                           template="inquiry"
                           [multiple]="false"
                           floatLabel="never"
                           [items]="inquiries$ | async"
                           (search)="search.next($event)"
                           [ctrl]="form.get('selected')" placeholder="Inquiry">
          <ng-container class="error-container">
            <mat-error>
              Inquiry is <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>

        <p [innerHtml]="config.help"></p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
      <i class="fal fa-times"></i> cancel
    </button>
    <button (click)="save(form)" type="button" class="btn btn-success text-uppercase create-btn">
      <i class="fal fa-check"></i> Select
    </button>
  </div>
</form>
